<div>
  <div class="nav-container-1">
    <div class="row">
      <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 tab-container">
        <mat-button-toggle-group #group="matButtonToggleGroup" class="sche-toggle-btn" style="width:auto"
          *ngIf="hasSuperView" [(ngModel)]='buttonType' (change)="onValChange(group.value)">
          <mat-button-toggle value="MyMessages" class="btn-primary">My Messages</mat-button-toggle>
          <mat-button-toggle value="Project" class="btn-primary">Other Messages</mat-button-toggle>
        </mat-button-toggle-group>
      </div>
    </div>
  </div>

  <div>
    <ssrs-reportviewer [reportserver]="reportServer" [reporturl]="reportUrl" [showparameters]="showParameters"
      [parameters]="parameters" [language]="language" [width]="width" [height]="height" [toolbar]="toolbar">
    </ssrs-reportviewer>
  </div>
</div>